export default "__VITE_ASSET__CBreLMI5__"